import angular from 'angular';
import {
  pmDataService,
  loaderService,
  ssDialogService,
  pmSharedModelService,
} from 'app/services';
import { alerts, confirmDialog } from 'app/components/global';

import boardApproveDialog from './dialog.boardApproveDialog';
import editPmDocumentDialog from '../dialog.editDocumentDialog';
import generateDocumentDialog from './dialog.generateDocumentDialog';
import editDocumentAttachmentDialog from '../dialog.editDocumentAttachmentDialog';
import syncRecommendedChangesDialog from '../dialog.syncRecommendedChangesDialog';
import documentAddendum from '../documentAddendum';
import documentSupportingDocument from '../documentSupportingDocument';
import section from './section';
import changeLogDialog from '../changeLog/dialog.changeLogDialog';
import changeLogItem from '../changeLog/changeLogItem';
import syncOutstandingRecommended from '../syncOutstandingRecommended';
import directive from './active-document.directive';
import controller from './active-document.controller';


export default angular.module('app.components.advisory.pm.activeDocument', [
  alerts,
  pmDataService,
  boardApproveDialog,
  confirmDialog,
  editPmDocumentDialog,
  generateDocumentDialog,
  loaderService,
  section,
  ssDialogService,
  editDocumentAttachmentDialog,
  syncRecommendedChangesDialog,
  documentAddendum,
  documentSupportingDocument,
  changeLogDialog,
  changeLogItem,
  syncOutstandingRecommended,
  pmSharedModelService,
])
  .directive('pmActiveDocument', directive)
  .controller('ActivePmDocumentController', controller)
  .name;

console.log('app.components.advisory.pm.activeDocument created');
